import React, { useState } from "react"
import { useHistory, useParams } from "react-router"
import { Box, Button } from "@material-ui/core"
import { KeyboardArrowLeft, KeyboardArrowRight } from "@material-ui/icons"
import CustomDialog from "../../Components/CustomDialog"
import { useStyles } from './style'
import one from '../../Assets/Images/stepper/1.svg'
import two from '../../Assets/Images/stepper/2.svg'
import stepper1 from '../../Assets/Images/stepper/stepper1.svg'
import stepper2 from '../../Assets/Images/stepper/stepper2.svg'

const Process = (props) => {
  const classes = useStyles()
  const history = useHistory()
  const [activeStep, setActiveStep] = useState(0)
  const { programId } = useParams()
  const steps = [
    {
      header: <>
        <Box className={classes.headerNumber}>
          <img src={one} className={classes.stepperNumberImg} alt="" />
        </Box>
        <Box display="flex" justifyContent="center" flexGrow="1">
          <img src={stepper1} className={classes.stepperImg} alt="" />
        </Box>
      </>,
      description: <>
        <Box>
          <Box component="span">{`Add a new system on homeowner’s behalf via `}</Box>
          <Box component="span" className={classes.stepperLink} onClick={() => history.push(`/programs/${programId}/systems-addition/application-form`)}>{`Add a new System`}</Box>
          <Box component="span">{` option and submit the application for Enphase verification`}</Box>
        </Box>
      </>,
    },
    {
      header: <>
        <Box className={classes.headerNumber}>
          <img src={two} className={classes.stepperNumberImg} alt="" />
        </Box>
        <Box display="flex" justifyContent="center" flexGrow="1">
          <img src={stepper2} className={classes.stepperImg} alt="" />
        </Box>
      </>,
      description:
        <Box>
          {`Once verification is successful, the site is successfully enrolled into the program.`}
        </Box>,
    },
  ]
  const maxSteps = 2

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1)
  }

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1)
  }

  const getProcessFlow = () => {
    return (
      <Box>
        <Box className={classes.processCard}>
          <Box display="flex">
            {steps[activeStep].header}
          </Box>
          <Box className={classes.stepperContent} sx={{ p: 2, mt: 2 }}>
            {steps[activeStep].description}
          </Box>
        </Box>
        <Box display="flex" justifyContent="space-between" p={1}>
          <Button size="small" onClick={handleBack} disabled={activeStep === 0} style={{ visibility: activeStep === 0 ? 'hidden' : '', color: '#000000' }}>
            <KeyboardArrowLeft />
            BACK
          </Button>
          <Box display="flex" alignItems="center">
            {steps.map((step, index) => (
              <Box key={index} color="primary" className={`${activeStep === index ? classes.customDotActive : classes.customDot}`} onClick={() => setActiveStep(index)} />
            ))}
          </Box>
          <Button
            size="small"
            onClick={handleNext}
            disabled={activeStep === maxSteps - 1}
            style={{ visibility: activeStep === maxSteps - 1 ? 'hidden' : '', color: '#000000' }}
          >
            NEXT
            <KeyboardArrowRight />
          </Button>
        </Box>
      </Box>
    )
  }

  return (
    <CustomDialog fullWidth maxWidth="sm" open={props.open} title="" content={getProcessFlow()} handleClose={props.handleClose} />
  )
}

export default Process